export default __webpack_public_path__ + "leaflet/dist/images/marker-shadow.png";